import { Outlet } from 'react-router-dom';
import { Container, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useDataPolling } from '../hooks/useDataPolling';
import { useUsuarioInit } from '../hooks/useUsuarioInit';

const MainContainer = styled(Container)({
  width: '100%',
  maxWidth: 'none !important',
});

const ContentWrapper = styled(Box)({
  width: '100%',
  maxWidth: '1818px',
  margin: '0 auto',
});

const MainContent = styled(Box)({
  paddingBottom: '50px',
});

const MainLayout = () => {
  useDataPolling();
  useUsuarioInit();

  return (
    <Box>
      <Header />
      <MainContainer disableGutters>
        <ContentWrapper>
          <MainContent>
            <Outlet />
          </MainContent>
        </ContentWrapper>
      </MainContainer>
      <Footer />
    </Box>
  );
};

export default MainLayout; 